var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/load/electrical.template.html');

var CookingAppliancesTable = require('../cooking_appliances_table.view.ts');
var EntertainmentOfficeTable = require('../entertainment_and_office_table.view.ts');
var WashingDryingCleaningTable = require('../washing_drying_cleaning_table.view.ts');
var OtherMiscellaneousTable = require('../other_miscellaneous_table.view.ts');

var TheView = GenericView.extend({
    el: '#electrical',
    tagName: '',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
        GenericView.prototype.storeView(this, "electrical");
    },
    superRender: GenericView.prototype.render,
    render: function () {
        this.superRender();
        this.$el.html(this.template);

        this.cooking_appliances_table = new CookingAppliancesTable();
        this.entertainment_office_table = new EntertainmentOfficeTable();
        this.washing_drying_cleaning_table = new WashingDryingCleaningTable();
        this.other_miscellaneous_table = new OtherMiscellaneousTable();
    },
    events: {
        "keyup .ac-input": "showSubQuestion",
        "keyup .sub-question.a": "showSubQuestionB",
        "change .table-of-usage tbody input": "allowOnlyOneSelected"
    },
    showSubQuestion: function() {
        var answer = $(".ac-input").val();
        if (answer==1 || answer==2) {
            $(".sub-question.a").show();
        } else {
            $(".sub-question.a").hide();
        }
    },
    showSubQuestionB: function() {
        $("#15b").empty();
        var answer = $(".sub-question.a input").val();
        for(var i=0; i<answer; i++) {
            $("#15b").append("<div id='15b" + (i+1) + "' class='w3-row sub-question sub-question-b'><div>Q15b What is the number of rooms can be heated or cooled by the air-conditioning unit " + (i+1) + " {2,3 or 4 rooms} ? </div><div><input class='answer-input' type='text' name='appliances'></div></div>");
        }
    },
    getAllData: function() {
        var data = {
            answers: this.getAnswers()
        };

        return data;
    },
    getAnswers: function() {
        var answers = this.getAnswersOfQ1_16();
        answers.push(this.getAnswersOfQ16());

        return answers;
    },
    getAnswersOfQ1_16: function() {
        var self = this;
        var answers = [];

        var questions = $("#electrical").find(".question");

        $.each(questions, function(index, value) {
            var temp_val = $(this).find(".answer-input").val();
            if (!isNaN(temp_val)) {
                temp_val = parseFloat(temp_val);
            }

            var temp = {
                question_id: parseInt($(this).attr("id")),
                value: temp_val
            }
            answers.push(temp);
        });

        var question_15b = $("#electrical").find(".sub-question-b");
        var values= [];
        $.each(question_15b, function(index, value) {
            var temp_val = $(this).find(".answer-input").val();
            if (!isNaN(temp_val)) {
                temp_val = parseInt(temp_val);
            }

            values.push(temp_val);
        });
        var q15b = {
            question_id: 152,
            value: values
        }

        answers.push(q15b);

        return answers;
    },
    getAnswersOfQ16: function() {
        var self = this;
        var answers = [];

        var rows = $(".table-of-usage tbody").find("tr");
        $.each(rows, function(index, value) {
            var temp = {
                appliance_category: $(this).parent().parent().data("appliance-category"),
                time: $(this).find("input:checked").length != 0 ? $($(this).find("input:checked")[0]).data("time-of-usage") : "NEVER",
                appliance_type: $(this).data("appliance-type"),
                type_of_day: $(this).parent().parent().parent().data("type-of-day")
            }
            answers.push(temp);
        });

        var ans = {
            question_id: 16,
            value: answers
        }


        return ans;
    },
    allowOnlyOneSelected: function(event) {
        var temp = $(event.currentTarget);
        temp.parent().parent().find("input:checked").not(temp).prop("checked", false);
    }
});

module.exports= TheView;